import * as React from "react";
import { cn } from "@/shadcn/lib/utils";
import { ChevronDownIcon } from "lucide-react";

const NativeSelect = React.forwardRef(function NativeSelect(
  { className, size = "default", ...props },
  ref
) {
  return (
    <div
      className={cn(
        "group/native-select relative w-fit has-[select:disabled]:opacity-50",
        className
      )}
      data-slot="native-select-wrapper"
      data-size={size}
    >
      <select
        data-slot="native-select"
        data-size={size}
        className="bg-input/50 border-transparent placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground focus-visible:border-ring focus-visible:ring-ring/30 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 h-9 w-full min-w-0 appearance-none rounded-3xl border py-1 pr-8 pl-3 text-sm transition-[color,box-shadow,background-color] select-none focus-visible:ring-3 aria-invalid:ring-3 data-[size=sm]:h-8 outline-none disabled:pointer-events-none disabled:cursor-not-allowed"
        ref={ref}
        {...props}
      />
      <ChevronDownIcon
        className="text-muted-foreground top-1/2 right-2.5 size-4 -translate-y-1/2 pointer-events-none absolute select-none"
        aria-hidden="true"
        data-slot="native-select-icon"
      />
    </div>
  );
});

const NativeSelectOption = React.forwardRef(function NativeSelectOption(
  { className, ...props },
  ref
) {
  return (
    <option
      data-slot="native-select-option"
      className={cn("bg-[Canvas] text-[CanvasText]", className)}
      ref={ref}
      {...props}
    />
  );
});

const NativeSelectOptGroup = React.forwardRef(function NativeSelectOptGroup(
  { className, ...props },
  ref
) {
  return (
    <optgroup
      data-slot="native-select-optgroup"
      className={cn("bg-[Canvas] text-[CanvasText]", className)}
      ref={ref}
      {...props}
    />
  );
});

export { NativeSelect, NativeSelectOptGroup, NativeSelectOption };
